import PromoPageComponent from './../components/PromoPageComponent/PromoPageComponent';

const PromoPage = ({ hideHeaderFooterSetter, hideLanguageSwitcherSetter }) => {
  return (
    <>
      <PromoPageComponent hideHeaderFooterSetter={hideHeaderFooterSetter} hideLanguageSwitcherSetter={hideLanguageSwitcherSetter}/>
    </>
  );
};

export default PromoPage;